import type { InspectionPointInstanceManager } from '../../digital-twin/graphics/inspection-point-instance-manager.service';
import { Section } from '../../platform/busines-data/Framework/Section';
import { GaugingElement } from '../../platform/busines-data/SectionElements/InspectionElements/gaugingElement';
import { instanceSnapshot, reinstancePoint } from '../inspection-retarget-transaction';

/**
 * dev draws inspection POINTs as InstancedMesh slots behind a PhantomSurfaceDesign (no parent, no
 * geometry), so Section.deleteElementByIdOnly cannot take them out of the scene: the slot itself must
 * go, or the point keeps rendering (and stays pickable) where it was. Real-mesh inspections (AREA,
 * ELEMENT, orphan points) are not registered in the manager and are left to the caller's delete.
 */
export function removePointInstance(manager: InspectionPointInstanceManager | null | undefined,
  point: GaugingElement): void {
  if (manager?.getInstanceInfo(point)) manager.removeInstance(point);
}

/**
 * A re-homed instanced POINT must keep pointing at the STRUCTURE section of its element (batch key,
 * phantom userData.SectionID and selection fallbacks read it), while campaign.addSurfaceElement
 * re-points `section` at the campaign's internal section. Batches are keyed by section Guid: when
 * the element changed section, the slot moves to the new section's batch (pose, colour and hidden
 * state kept); otherwise it already lives in the right batch.
 */
export function rehomePointInstance(manager: InspectionPointInstanceManager | null | undefined,
  point: GaugingElement, structureSection: Section | null | undefined): void {
  const info = manager?.getInstanceInfo(point);
  if (!info || !structureSection) return;
  point.section = structureSection;
  const phantom = point.SurfaceDesign;
  if (phantom?.userData) phantom.userData.SectionID = structureSection.Guid;
  if (manager.getMeshesForSection(structureSection)?.get(info.shapeType) === info.mesh) return;
  const snapshot = instanceSnapshot(manager, point, structureSection);
  if (snapshot) reinstancePoint(manager, point, structureSection, snapshot.shapeType, snapshot.matrix, snapshot.color);
}
